// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".theme-text-color-format-popover .components-popover__content {\n  padding: 15px;\n}\n\n.rich-text .text-color.primary {\n  color: var(--base-theme-primary-color);\n}\n.rich-text .text-color.secondary {\n  color: var(--base-theme-secondary-color);\n}\n.rich-text .text-color.tertiary {\n  color: var(--base-theme-tertiary-color);\n}\n.rich-text .text-color.light {\n  color: var(--base-theme-light);\n}\n.rich-text .text-color.dark {\n  color: var(--base-theme-dark);\n}", ""]);
// Exports
module.exports = exports;
